module.exports = __webpack_public_path__ + "img/logo-spokes.aff15b61.png";